import { cardsLoaded, filters } from '../../redux/selectors'
import { useMediaQuery } from 'react-responsive'
import { useMatch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Wrapper from './components/wrapper'


const Filters = () => {
   const isNotDesktop = useMediaQuery({ query: '(max-width: 1199.98px)' })
   const match = useMatch({ path: 'products/:url' })
   const url = match?.params?.url
   const loaded = useSelector(cardsLoaded(url))
   const items = useSelector(filters(url))

   if (!loaded || !isNotDesktop && !url) return null

   return <Wrapper items={items} url={url} />
}

export default Filters
